
import React from 'react';

const NewsletterSection: React.FC = () => {
  return (
    <section className="py-16 bg-[#8B4E2E] text-white" aria-labelledby="newsletter-heading">
      <div className="container mx-auto px-4 max-w-5xl">
        <style dangerouslySetInnerHTML={{ __html: `
          .mc-cool-form {
              display: grid;
              grid-template-columns: 1fr 1fr;
              gap: 40px;
              align-items: center;
          }

          @media (max-width: 768px) {
              .mc-cool-form {
                  grid-template-columns: 1fr;
                  gap: 20px;
              }
          }
          
          .form__label {
              display: block;
              margin-bottom: 0.5rem;
              font-weight: 500;
          }
          
          .form__label-required {
              color: #FFD700;
          }
          
          .form__input {
              width: 100%;
              padding: 0.75rem 1rem;
              background-color: rgba(255, 255, 255, 0.1);
              border: 1px solid rgba(255, 255, 255, 0.3);
              border-radius: 0.375rem;
              color: white;
              margin-bottom: 1rem;
          }
          
          .form__input:focus {
              outline: none;
              border-color: rgba(255, 255, 255, 0.6);
              box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.2);
          }
          
          .form__group {
              margin-bottom: 1rem;
          }
          
          .sb-button--form {
              background-color: white;
              color: #8B4E2E;
              font-weight: 600;
              padding: 0.75rem 1.5rem;
              border-radius: 0.375rem;
              border: none;
              cursor: pointer;
              transition: all 0.3s ease;
              font-size: 1rem;
          }
          
          .sb-button--form:hover {
              background-color: #FFD700;
              transform: translateY(-2px);
          }
          
          #mc_embed_signup div.mce_inline_error {
              background-color: rgba(255, 0, 0, 0.3) !important;
              font-weight: normal !important;
          }
        ` }} />
        <div className="mc-cool-form">
          <div className="mc-cool-form-content">
            <h2 className="text-3xl md:text-4xl font-bold mb-2 font-montserrat"><strong>Be the First to Know About Our Tours!</strong></h2>
            <h3 className="text-xl font-semibold mb-4 font-montserrat">Join the Cat Tour Insider List Today!</h3>
            <p className="mb-6 text-white/90 font-lora">
              Sign up to get first dibs on new tour dates, special announcements, and booking reminders. Don't miss your chance to pounce on tickets for our historical cat-ventures through NYC's most meow-velous neighborhoods!
            </p>
          </div>
          <div id="mc_embed_shell">
            <div id="mc_embed_signup">
              <form
                action="https://catsabouttowntours.us11.list-manage.com/subscribe/post?u=0d2a33482ae5dafc62ce46cf1&amp;id=5059a17d46&amp;f_id=004f9ce0f0"
                method="post"
                id="mc-embedded-subscribe-form"
                name="mc-embedded-subscribe-form"
                className="validate form"
                target="_blank"
              >
                <input type="hidden" name="tags" value="9327351" />
                <div id="mc_embed_signup_scroll">
                  <div className="form__group">
                    <label className="form__label" htmlFor="mce-EMAIL">
                      Email Address <span className="form__label-required">*</span>
                    </label>
                    <input
                      type="email"
                      name="EMAIL"
                      className="required form__input"
                      id="mce-EMAIL"
                      required
                      value=""
                    />
                  </div>
                  <div className="form__group">
                    <label className="form__label" htmlFor="mce-FNAME">
                      First Name <span className="form__label-required">*</span>
                    </label>
                    <input
                      type="text"
                      name="FNAME"
                      className="required form__input"
                      id="mce-FNAME"
                      required
                      value=""
                    />
                  </div>
                  <div className="form__group">
                    <label className="form__label" htmlFor="mce-LNAME">Last Name </label>
                    <input
                      type="text"
                      name="LNAME"
                      className="form__input"
                      id="mce-LNAME"
                      value=""
                    />
                  </div>
                  <div className="form__group">
                    <label className="form__label" htmlFor="mce-CONSENT">
                      <input
                        type="checkbox"
                        name="CONSENT"
                        className="required mr-2"
                        id="mce-CONSENT"
                        required
                        value="true"
                      />
                      I agree to receive emails from Cats About Town Tours and understand I can unsubscribe at any time.
                    </label>
                  </div>
                  <div id="mce-responses" className="clear">
                    <div
                      className="response"
                      id="mce-error-response"
                      style={{ display: "none" }}
                    ></div>
                    <div
                      className="response"
                      id="mce-success-response"
                      style={{ display: "none" }}
                    ></div>
                  </div>
                  <div aria-hidden="true" style={{ position: "absolute", left: "-5000px" }}>
                    <input
                      type="text"
                      name="b_0d2a33482ae5dafc62ce46cf1_5059a17d46"
                      tabIndex={-1}
                      value=""
                    />
                  </div>
                  <div className="mt-4">
                    <button
                      type="submit"
                      name="subscribe"
                      className="sb-button sb-button--form"
                    >Submit</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewsletterSection;
